module.exports = __webpack_public_path__ + "public/images/shedule-ak.c5b3402b4cb9d427fb6a117a2ac7769a.png";